// extracted by mini-css-extract-plugin
export var card = "_4s-0";
export var content = "_4s-1";
export var contentLoading = "_4s-2";